import React, { useRef, useState, useEffect } from "react";
import "./SolutionsSection.css";
import introVideo from "../../assets/home/short_marketing_video.mp4";

const SolutionsSection = () => {
  const videoRef = useRef(null);
  const [isMuted, setIsMuted] = useState(false);

  useEffect(() => {
    if (videoRef.current) {
      try {
        videoRef.current.muted = isMuted;
        videoRef.current.play();
      } catch (e) {
        console.warn("Autoplay might be restricted:", e);
      }
    }
  }, [isMuted]);

  const handleMuteToggle = () => {
    setIsMuted((prev) => !prev);
  };

  return (
    <section className="solutions-container">

      {/* TITLE ABOVE VIDEO */}
      <div className="solutions-header">
        <p className="solutions-subtitle">
          Comprehensive fintech solutions for businesses and individuals
        </p>
        <h2 className="solutions-title">
          <span className="solutions-highlight">Solutions</span>
          <span className="solutions-normal">We Provide</span>
        </h2>
      </div>

      {/* VIDEO */}
      <div className="solutions-video">
        <video
          ref={videoRef}
          src={introVideo}
          autoPlay
          loop
          playsInline
          muted={isMuted}
          className="video-player"
        />

        <button
          className="unmute-overlay"
          onClick={handleMuteToggle}
          type="button"
        >
          {isMuted ? "🔇 Unmute" : "🔊 Mute"}
        </button>
      </div>

      {/* LIST */}
      <div className="solutions-side">
        <ul className="solutions-list">
          <li>Pay bills, leasing, water, and electricity quickly and securely.</li>
          <li>Split payments among friends or payees effortlessly.</li>
          <li>Calculate taxes and download detailed crypto reports.</li>
          <li>Manage employee attendance, profiles, and performance with ease.</li>
          <li>
            Track inventory, sales, and store operations in supermarkets, food
            cities, and retail outlets.
          </li>
          <li>
            Process orders and payments efficiently with a reliable cashier
            system.
          </li>
        </ul>
      </div>
    </section>
  );
};

export default SolutionsSection;
